module.exports = __webpack_public_path__ + "img/sandbox.48bee3f.svg";